import classnames from 'classnames';

import { Badge } from '../../Badge';

import styles from './KanbanCard.module.scss';
import { Props } from './KanbanCard.types';

export const KanbanCard = ({ title, className, subtitle, badges, actionButton }: Props) => {
  return (
    <div className={classnames(styles.container, className)}>
      <div className={styles.popupMenu}>{actionButton}</div>
      <div className={styles.badgesContainer}>
        {badges?.map(badge => (
          <Badge
            color={badge.badgeColor ?? 'blue'}
            className={classnames(styles.badge, badge.badgeClassName)}
          >
            {badge.badgeTitle}
          </Badge>
        ))}
      </div>
      <p className={styles.title}>{title}</p>
      <p className={styles.subtitle}>{subtitle}</p>
    </div>
  );
};
